import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { Link } from "react-router-dom";

const CameraSnapshotPop = ({ inspNo, scrapAreaCd }) => {
  console.log(inspNo, scrapAreaCd);
  const [show, setShow] = useState(true);

  const [snapshot, setSnapshot] = useState(null);
  const handleClose = (returnData) => {
    setShow(false);
  };

  //검수녹화 검색 URL
  const SERARCH_INSPECTION_SNAPSHOT_URL =
    "/domesticscrap/searchInspectionSnapshotList.do";

  //const SNAPSHOT_SERVER_URL = "http://localhost:7090";

  //const SNAPSHOT_SERVER_URL = "http://imsns.idaehan.com:8080";
  const SNAPSHOT_SERVER_URL_GP = "https://imsrelaygp.idaehan.com:8443";
  const SNAPSHOT_SERVER_URL_NS = "https://imsns.idaehan.com:8443";
  const SNAPSHOT_SERVER_URL_NRC = "https://imsrelaynrc.idaehan.com:8443";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SERARCH_INSPECTION_SNAPSHOT_URL,
    },
    { manual: true }
  );

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    handleSearch();
  }, []);

  const handleSearch = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_INSPECTION_SNAPSHOT_URL,
      params: {
        inspNo: inspNo,
      },
    });

    setSnapshot(data);
  };

  const handleOk = (returnData) => {
    setShow(false);
  };

  return (
    <>
      <Modal show={show} onHide={() => handleClose(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title> 검수녹화이미지 </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="searchdata">
            <table className="t_garo">
              {snapshot &&
                snapshot.map((image, index) => (
                  <>
                    <tr>
                      <th style={{ textAlign: "center", padding: "0" }}>
                        <Link
                          to="#"
                          onClick={() =>
                            window.open(
                              (scrapAreaCd.indexOf("1200N") >= 0
                                ? SNAPSHOT_SERVER_URL_NRC
                                : scrapAreaCd.indexOf("2100") >= 0
                                ? SNAPSHOT_SERVER_URL_GP
                                : SNAPSHOT_SERVER_URL_NS) + image.url,
                              "_blank"
                            )
                          }
                        >
                          <div id="map_div" style={{ textAlign: "center" }}>
                            <img
                              src={
                                (scrapAreaCd.indexOf("1200N") >= 0
                                  ? SNAPSHOT_SERVER_URL_NRC
                                  : scrapAreaCd.indexOf("2100") >= 0
                                  ? SNAPSHOT_SERVER_URL_GP
                                  : SNAPSHOT_SERVER_URL_NS) + image.url
                              }
                              style={{ width: "600px", height: "400px" }}
                              alt="img"
                            />
                          </div>
                        </Link>
                      </th>
                    </tr>
                  </>
                ))}
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleOk(true)}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const ModalCameraSnapshotPop = createModal(CameraSnapshotPop);

export default CameraSnapshotPop;
